
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
// import { AppConstant } from './../../shared/constant/app.constant';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};

@Injectable()
export class PublicHolidayService {
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    getPublicHoliday() {
        return this.http.get(`setups/public-holiday`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    save(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/public-holiday`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getEndOfDay() {
        return this.http.get(`admin/end-of-day`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    runEodOperation(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`admin/end-of-day`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    update(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`setups/public-holiday/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}